import { useCallback, useState } from "react"
import { retreiveEarlyBird, retreiveEarlyBirdSummary } from "src/pages/admin/services/whitelistService"
import { EarlyBirdRecord, EarlyBirdSummary } from "./List"

const useEarlyBird = () => {
  const [records, setRecords] = useState<EarlyBirdRecord[]>([])
  const [total, setTotal] = useState(0)
  const [summary, setSummary] = useState<EarlyBirdSummary>()

  const retrieve = useCallback(async (page: number, pageSize: number) => {
    try {
      const response = await retreiveEarlyBird(page, pageSize)

      setRecords(response.data.items)
      setTotal(response.data.total || 0)

    } catch (error) {
      console.log("error: ", error)
    }
  }, [])

  const retrieveSummary = useCallback(async () => {
    try {
      const response = await retreiveEarlyBirdSummary()

      setSummary(response.data)

    } catch (error) {
      console.log("error: ", error)
    }
  }, [])

  return {
    retrieve,
    retrieveSummary,
    records,
    total,
    summary
  }
}

export default useEarlyBird